import { SelectOption } from 'common/types/select-option';
import { useDistinctCarKeysLazy } from 'data/useDistinctCarKeys';
// import { useListingsSearch } from 'data/useListingsSearch';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { cacheActions, cacheSelectors } from 'redux/cache.slice';
import { RootState } from 'redux/root-reducer';
import { searchParamActions, searchParamSelectors } from 'redux/search-param.slice';

export const allModels: SelectOption = { label: 'All Models', id: '' };

export interface MakeModels {
  make: string;
  models: string[];
}

export const useModels = () => {
  const dispatch = useDispatch();
  const makeModels = useSelector((state: RootState) => searchParamSelectors.makeModels(state));
  // const { updateMakeModels } = useListingsSearch();
  const { getModels } = useDistinctCarKeysLazy();

  const getModelOptions = (make: string): SelectOption[] => {
    return _.orderBy(getModels(make), ['model']).map(x => ({ id: x.model, label: x.model })) as SelectOption[];
  };

  const getSelectedModel = (make: string) => {
    const item = makeModels?.find(x => x.make === make);
    if (!item?.models.length) return '';
    return item.models[0];
  };
  const getSelectedModels = (make: string) => makeModels?.find(x => x.make === make)?.models || [];

  const setSelectedModels = (make: string, keys: string[], disableSearch?: boolean) => {
    const newSelectedMakeModels = _.cloneDeep(makeModels);
    const makeModel = newSelectedMakeModels?.find(x => x.make === make);
    if (!makeModel) throw new Error('missing make for setSelectedModels');
    makeModel.models = _.orderBy(keys);
    dispatch(searchParamActions.makeModels(newSelectedMakeModels));
    // if (!disableSearch) updateMakeModels(newSelectedMakeModels);
  };
  // const removeModelId = (make: string, key: string) => {
  //   const newSelectedMakeModels = _.cloneDeep(makeModels);
  //   const item = newSelectedMakeModels?.find(x => x.make === make);
  //   if (item?.models)
  //     item.models.splice(
  //       item.models.findIndex(x => x),
  //       1,
  //     );
  //   dispatch(searchParamActions.makeModels(newSelectedMakeModels));
  //   // updateMakeModels(newSelectedMakeModels);
  // };

  const addModelKey = (makeKey: string, val: string) => {
    console.log({ makeKey, val, makeModels });
    const ary = _.cloneDeep(makeModels || []);
    const make = ary.find(x => x.make === makeKey);
    if (make) {
      console.log('pushing');
      if (!make.models.find(x => x === val)) make.models.push(val);
      dispatch(searchParamActions.makeModels(ary));
    }
  };

  const removeModelKey = (makeKey: string, val: string) => {
    const ary = makeModels ? _.cloneDeep(makeModels) : [];
    const make = ary.find(x => x.make === makeKey);
    if (make) {
      make.models = make.models.filter(x => x !== val);
      dispatch(searchParamActions.makeModels(ary));
    }
  };

  return {
    getModelOptions,
    getSelectedModel,
    getSelectedModels,
    setSelectedModels,
    addModelKey,
    removeModelKey,
  };
};
